import React from "react";
import Avatar from "../../../../../../../common/avatar/avatar";

interface UserInfoProps {
  userName: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ userName }) => (
  <div className="flex items-center">
    <Avatar size="small" />
    <div className="ml-2 flex flex-col font-ubuntu text-base text-primary">
      <span>{userName}</span>
    </div>
  </div>
);

export default UserInfo;
